var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_GradientLayerGroup = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_CanvasLayerGroup(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        class_name: "GradientLayerGroup"
    });
};